/**
 * Angular imports.
 */
import { Component, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';

/**
 * Rxjs imports.
 */
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

/**
 * Service imports.
 */
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';
import { GetService } from '../../../dataservices/get.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';

/**
 * Interface import.
 */
import { AnalyticsInterface } from '../../../analytics-event/analytics.model';
/**
  * Constant import.
  */
import { EVENT_NAME } from './../../../analytics-event/analytics.constant';
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from '../../../constants/app.constants';
/**
 * Service imports.
 */
import { AnalyticsEventService } from './../../../analytics-event/analytics-event.service';

/**
 * posting service
 */
import { PostingService } from '../posting.service';
/**
 * sdk imports 
 */
import { Analytics } from 'analytics2.0';
import { ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';

/**
 * Tag Connection Component
 */
@Component({
  selector: 'app-tag-connection',
  templateUrl: './tag-connection.component.html',
  styleUrls: ['./tag-connection.component.scss']
})
export class TagConnectionComponent implements OnInit, OnDestroy {

  @Output() nextPostScreen = new EventEmitter();

  @Input() callingFrom;
  public offset = 1;
  public search_type = 'connection';
  public keyword = '';
  public connection_data = { header: '', subtitle: '', view_more_text: '', total_connections: 0, list: [] };
  public suggestion_data = { header: '', subtitle: '', view_more_text: '', list: [] };
  public api_in_process = false;
  public err_msg = '';
  public showTagProcessed = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public hasChanged = false;
  public deleteTagObj: string;
  public finished = false;
  public is_suggestion = 1;
  public showConn = 'both';
  public only_connection_offset = 1;
  public only_connection_list_data = { header: '', subtitle: '', view_more_text: '', total_connections: 0, list: [] };
  public subject: Subject<string> = new Subject();

  /**
  * Filter key for connection API.
  */
  public filter = {};

  /**
   * Set analytics start time.
   */
  private sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   * Set analytics tag next click object.
   */
  public analyticsDataTagNextClick: AnalyticsInterface;
  /**
   * Set analytics entry event.
   */
  public analyticsDataEntryEvent: AnalyticsInterface;
  /**
   * Set analytics visit event.
   */
  public analyticsVisitData: AnalyticsInterface;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * screen name
   */
  private screenName = SCREEN_NAME.TAG_PEOPLE;


  /**
   * Necessary instances.
   */
  constructor(
    public dss: DataStorageService,
    private jwtSer: JwtDecodeService,
    private getConnectionSer: GetService,
    public fcs: FunCollectionService,
    public multilang: MultiLangService,
    public mls: NewLanguageService,
    private analyticSdk: Analytics,
    private postingService: PostingService) {
    this.dss.tagedUser = this.dss.posting_data.screen1.tag_to.map(el => el);
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.connectionList();
    this.subscriptions.add(this.subject.pipe(
      debounceTime(300)
    ).subscribe(x => {
      this.keyword = x;
      if (this.showConn == 'both') {
        this.offset = 1;
        this.is_suggestion = 1;
        this.search_type = 'connection';
        this.connection_data = { header: '', subtitle: '', view_more_text: '', total_connections: 0, list: [] };
        this.suggestion_data = { header: '', subtitle: '', view_more_text: '', list: [] };
        if (this.api_in_process == false) {
          this.connectionList();
        }
      } else {
        this.getOnlyConnection();
      }
    }));

    /**
     * Set analytics for next click event.
     */
    this.analyticsDataTagNextClick = {
      'event_name': EVENT_NAME.POST_TAG_NEXT_CLICK,
      'product_type': 0,
      'product_type_id': 0,
      'screen_name': SCREEN_NAME.TAG_PEOPLE
    };
    /**
     * Set analytics start time.
     */
    this.sessiontime.start_time = new Date().getTime().toString();

    /**
     * Set analytics data for analytics event.
     */
    const entryData: ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING,
      entity_code: this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0',
      current_screen_name: SCREEN_NAME.TAG_PEOPLE,
      source: this.callingFrom,
      start_time: parseInt(this.sessiontime.start_time)
    };
    this.analyticSdk.analyticService.ENTRY(entryData);
    this.postingService.postingScreen = SCREEN_NAME.TAG_PEOPLE;
    this.postingService.postingScreen = SCREEN_NAME.POST_DRAFT_LIST;
  }

  /**
   * get Only Connection
   */
  getOnlyConnection(): void {
    this.only_connection_offset = 1;
    this.showConn = 'connection';
    this.search_type = 'connection';
    this.is_suggestion = 0;
    this.only_connection_list_data = { header: '', subtitle: '', view_more_text: '', total_connections: 0, list: [] };

    this.getConnectionList();
  }

  /**
   * Back To suggestion and connection
   */
  backTosugg_and_conn(): void {
    this.showConn = 'both';
    this.is_suggestion = 1;
  }

  /**
   * Remover connection search
   */
  resetSearchBox(): void {
    document.querySelector<HTMLInputElement>('#conSearch').value = '';
    this.keyword = '';
    this.connection_data.list = [];
    this.offset = 1;
    setTimeout(() => {
      this.getConnectionList();
      this.connectionList();
    }, 200);
  }

  /**
   * get Connection List
   */
  getConnectionList(): void {
    if (this.only_connection_offset == 0) { return; }
    this.api_in_process = true;
    this.subscriptions.add(this.getConnectionSer.getconnectionList(this.search_type, this.only_connection_offset, this.is_suggestion, this.keyword, this.filter).subscribe(resData => {
      this.api_in_process = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          this.only_connection_offset = data.data.offset;
          for (let i = 0; i < data.data.search_list.length; i++) {
            if (data.data.search_list[i].key == 'connection') {
              this.only_connection_list_data.header = data.data.search_list[i].header;
              this.only_connection_list_data.subtitle = data.data.search_list[i].subtitle;
              this.only_connection_list_data.view_more_text = data.data.search_list[i].view_more_text;
              this.only_connection_list_data.total_connections = data.data.search_list[i].total_connections;
              this.only_connection_list_data.list = this.only_connection_list_data.list.concat(data.data.search_list[i].list);
            }
          }

        } else if (data.status == 0) {
          this.fcs.errorHandeler(data);
        }
      }, () => {
        this.api_in_process = false;
      });
    }));
  }

  /**
   * connection List
   */
  connectionList(): void {
    if (this.offset == 0) { return; }
    this.api_in_process = true;
    this.subscriptions.add(this.getConnectionSer.getconnectionList(this.search_type, this.offset, this.is_suggestion, this.keyword, this.filter).subscribe(resData => {
      this.api_in_process = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          this.offset = data.data.offset;
          for (let i = 0; i < data.data.search_list.length; i++) {
            if (data.data.search_list[i].key == 'connection') {
              this.connection_data.header = data.data.search_list[i].header;
              this.connection_data.subtitle = data.data.search_list[i].subtitle;
              this.connection_data.view_more_text = data.data.search_list[i].view_more_text;
              this.connection_data.total_connections = data.data.search_list[i].total_connections;
              this.connection_data.list = this.connection_data.list.concat(data.data.search_list[i].list);
            }
            if (data.data.search_list[i].key == 'suggestion') {

              this.suggestion_data.header = data.data.search_list[i].header;
              this.suggestion_data.subtitle = data.data.search_list[i].subtitle;
              this.suggestion_data.view_more_text = data.data.search_list[i].view_more_text;
              this.suggestion_data.list = this.suggestion_data.list.concat(data.data.search_list[i].list);
            }
          }
        } else if (data.status == 0) {
          this.fcs.errorHandeler(data);
        }
      }, () => {
        this.api_in_process = false;
      });
    }));
  }

  /**
   * add Tag
   */
  addTagTo(e, conn): boolean {
    this.err_msg = '';
    if (e.target.checked == true) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.TAG_PEOPLE, CTA_TYPE.CHECKBOX, ACTION_TYPE.CLICK, ACTION_ON.SELECT_USER_TAG, null);
      if (this.dss.tagedUser.length > 4) {
        this.err_msg = 'You can tag max 5 members';
        e.target.checked = false;
        return false;
      }
      this.showTagProcessed = true;
      this.dss.tagedUser.push(conn);
    } else {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.TAG_PEOPLE, CTA_TYPE.CHECKBOX, ACTION_TYPE.CLICK, ACTION_ON.REMOVE_TAG_USER, null)
      const index = this.dss.tagedUser.findIndex((item) => {
        return item.custom_id === e.target.value;
      });
      if (index != -1) {
        this.dss.tagedUser.splice(index, 1);
      }
    }
  }

  /**
   * check Value
   */
  checkVal(conn): boolean {
    const x = this.dss.tagedUser.filter(x => x.custom_id == conn.custom_id);
    return (x.length > 0) ? true : false;
  }

  /**
   * unTag
   */
  unTag(conn): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.TAG_PEOPLE, CTA_TYPE.ICON, ACTION_TYPE.CLICK, ACTION_ON.REMOVE_TAG_USER, null)
    this.hasChanged = !this.hasChanged;
    this.deleteTagObj = conn.custom_id;
    const index = this.dss.tagedUser.findIndex((item) => {
      return item.custom_id === conn.custom_id;
    });
    if (index != -1) {
      this.dss.tagedUser.splice(index, 1);
    }
  }

  /**
   * onScroll
   */
  onScroll(): void {
    this.search_type = 'suggestion';
    if (this.offset > 1) {
      this.finished = false;
      this.connectionList();
    }
  }

  /**
   * reset Error Msg
   */
  resetErrorMsg(): void {
    this.err_msg = 'You can tag max 5 members';
  }

  /**
   * proceed To Next Screen
   */
  proceedToNextScreen(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.TAG_PEOPLE, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.NEXT, null);
    this.dss.posting_data.screen1.tag_to = this.dss.tagedUser;
    this.nextPostScreen.emit(0);
  }

  /**
   * back To Previous
   */
  backToPrevious(): void {
    this.dss.tagedUser = [];
    this.nextPostScreen.emit(0);
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    /**
     * Set analytics end time.
     */
    this.sessiontime.end_time = new Date().getTime().toString();
    /**
     * Set analyics data on ngDestroy.
     */
    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING,
      entity_code: this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0',
      current_screen_name: SCREEN_NAME.TAG_PEOPLE,
      start_time: parseInt(this.sessiontime.start_time),
      end_time: parseInt(this.sessiontime.end_time)
    };
    this.analyticSdk.analyticService.EXIT(exitData);
  }
}
